/* blocks */
import CustomerPageHero from './components/CaseStudyHomePageHero/CaseStudyHomePageHero'
import FeaturedCaseStudies from './components/FeaturedCaseStudies/FeaturedCaseStudies'
import MoreCaseStudies from './components/MoreCaseStudies/MoreCaseStudies'
import TrustedPartner from './components/TrustedPartner/TrustedPartner'
import CaseStudyTestimonial from './components/CaseStudyTestimonial/CaseStudyTestimonial'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import {
  AllCaseStudyPageAttributes,
  CustomerPageAttributes
} from '@/utils/queries/customer_case_study'

interface Props {
  data: CustomerPageAttributes
  caseStudies: {
    attributes: AllCaseStudyPageAttributes
  }[]
}

function CustomerPageTemplate({ data, caseStudies }: Props): JSX.Element {
  const featuredCaseStudies = caseStudies.filter(
    data => data.attributes.isFeatured === true
  )

  return (
    <>
      <CustomerPageHero
        title={data.heroTitle}
        description={data.heroDescription}
        featuredImage={data.heroImage.data.attributes}
        awardsList={data.awardsList.data.map(item => ({
          url: item.attributes.url,
          alternativeText: item.attributes.alternativeText ?? '',
          width: item.attributes.width,
          height: item.attributes.height
        }))}
        primaryCta={data.heroPrimaryCta}
        secondaryCta={data.heroSecondaryCta}
      />

      {featuredCaseStudies.length > 0 ? (
        <FeaturedCaseStudies
          data={featuredCaseStudies.map(item => ({
            slug: item.attributes.slug,
            heroTitle: item.attributes.heroTitle,
            customerLogo: item.attributes.customerLogo.data.attributes,
            customerLogoWhite:
              item.attributes.customerLogoWhite.data.attributes,
            thumbnailImage:
              item.attributes.caseStudyThumbnailImage.data.attributes,
            statisticsList: item.attributes.statisticsList
          }))}
        />
      ) : null}

      {caseStudies.length > 0 ? (
        <MoreCaseStudies
          title="More Case Studies"
          data={caseStudies}
          isHomePage={true}
        />
      ) : null}

      <TrustedPartner />

      {data.testimonialList.data.length > 0 ? (
        <CaseStudyTestimonial
          list={data.testimonialList.data.map(item => ({
            authorDesignation: item.attributes.authorDesignation,
            authorName: item.attributes.authorName,
            company: item.attributes.company,
            companyImage: item.attributes.companyImage,
            review: item.attributes.review,
            authorImage: item.attributes.authorImage
          }))}
        />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
          mode="full_width"
          variant="blue"
        />
      ) : null}
    </>
  )
}

export default CustomerPageTemplate
